// extracted by mini-css-extract-plugin
export default {"pagination":"SuperPagination_pagination__moaPh","text1":"SuperPagination_text1__gTWcK","text2":"SuperPagination_text2__cbeRw"};